document
  .getElementById('search-mobile-toggle')
  .addEventListener('click', () => {
    const searchDropdown = document.getElementById('search-mobile')
    if (searchDropdown.style.maxHeight) {
      searchDropdown.style.maxHeight = null
    } else {
      searchDropdown.style.maxHeight = searchDropdown.scrollHeight + 'px'
      searchDropdown.querySelector('input[type="search"').focus()
    }
  })
